import React, { useState } from "react";
import { Link } from "react-router-dom";
import togiImage from "./togi.png";

const MaxWins = () => {
  const [maxWins] = useState([
    {
      id: 1,
      date: "2025-09-15",
      amount: 50000,
      game: "Slot Machine",
      casino: "Caesars Palace",
      description: "Hit the jackpot on Ferda Kids slot machine",
      donationAmount: 10000,
      recipient: "Sarah M.",
      recipientAge: 8,
      recipientStory:
        "Sarah was diagnosed with leukemia at age 6 and has been fighting bravely for 2 years. She loves drawing and dreams of becoming an artist. This donation helped cover her treatment, and Sarah is now in remission! 💜",
      recipientPhoto: "👧",
      status: "completed",
      kickVideoUrl:
        "https://kick.com/togi/videos/f88c5ebc-ec89-4614-98f4-21ebe6adcf10",
    },
    {
      id: 2,
      date: "2025-09-10",
      amount: 25000,
      game: "Blackjack",
      casino: "Bellagio",
      description: "Perfect 21 hand with 5 cards",
      donationAmount: 5000,
      recipient: "Alex K.",
      recipientAge: 12,
      recipientStory:
        "Alex has been battling bone cancer with incredible strength. He loves basketball and dreams of playing professionally one day. He never stops practicing, even during chemo. This donation helped his family with medical bills, and Alex is now back on the court! 🏀",
      recipientPhoto: "🏀",
      status: "completed",
      kickVideoUrl: "",
    },
    {
      id: 3,
      date: "2025-09-05",
      amount: 15000,
      game: "Poker",
      casino: "Aria",
      description: "Royal flush in Texas Hold'em",
      donationAmount: 3000,
      recipient: "Emma L.",
      recipientAge: 10,
      recipientStory:
        "Emma is a brilliant 10-year-old who wants to cure cancer when she grows up. She's been fighting brain cancer for 18 months with incredible courage. Emma loves science experiments and dreams of becoming a researcher. This donation supported her family during treatment, and Emma is now back in school! 🔬",
      recipientPhoto: "🔬",
      status: "completed",
      kickVideoUrl: "",
    },
  ]);

  const totalWinnings = maxWins.reduce((sum, win) => sum + win.amount, 0);
  const totalDonated = maxWins.reduce(
    (sum, win) => sum + win.donationAmount,
    0
  );

  return (
    <div className="max-w-6xl w-full">
      {/* Header */}
      <div className="text-center mb-12">
        <div className="flex justify-center items-center gap-6 mb-6">
          <div className="relative group">
            <img
              src={togiImage}
              alt="Togi"
              className="h-24 w-24 rounded-full border-3 border-yellow-400 shadow-lg object-cover hover:shadow-yellow-400/50 transition-all duration-300"
            />
            <div className="absolute -top-1 -right-1 w-6 h-6 bg-yellow-400 rounded-full flex items-center justify-center text-black font-bold text-xs">
              💰
            </div>
          </div>
          <h1 className="text-5xl font-bold text-white bg-gradient-to-r from-yellow-400 via-orange-400 to-red-400 bg-clip-text text-transparent">
            🎰 TOGI'S MAX WINS 🎰
          </h1>
        </div>
        <p className="text-gray-300 text-xl max-w-3xl mx-auto">
          Every max win creates real impact. Watch the wins, meet the kids, and
          see how your support changes lives.
        </p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
        <div className="bg-gradient-to-r from-green-500/20 to-blue-500/20 backdrop-blur-sm p-6 rounded-2xl border border-green-400/30">
          <h3 className="text-green-400 font-bold text-3xl mb-2">
            ${totalWinnings.toLocaleString()}
          </h3>
          <p className="text-gray-300">Total Winnings</p>
        </div>
        <div className="bg-gradient-to-r from-purple-500/20 to-pink-500/20 backdrop-blur-sm p-6 rounded-2xl border border-purple-400/30">
          <h3 className="text-purple-400 font-bold text-3xl mb-2">
            ${totalDonated.toLocaleString()}
          </h3>
          <p className="text-gray-300">Total Donated</p>
        </div>
        <div className="bg-gradient-to-r from-yellow-500/20 to-orange-500/20 backdrop-blur-sm p-6 rounded-2xl border border-yellow-400/30">
          <h3 className="text-yellow-400 font-bold text-3xl mb-2">
            {maxWins.length}
          </h3>
          <p className="text-gray-300">Lives Changed</p>
        </div>
      </div>

      {/* Video Showcase */}
      <div className="space-y-8">
        <h2 className="text-3xl font-bold text-white text-center mb-8 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
          🎬 Watch the Wins, Meet the Kids
        </h2>

        {maxWins.map((win) => (
          <div
            key={win.id}
            className="bg-gradient-to-br from-gray-800/40 to-gray-900/40 backdrop-blur-sm rounded-2xl p-8 border border-gray-600/30"
          >
            {/* Win Header */}
            <div className="text-center mb-6">
              <div className="inline-flex items-center gap-3 bg-gradient-to-r from-yellow-500/20 to-orange-500/20 px-6 py-3 rounded-full border border-yellow-400/30 mb-4">
                <span className="text-2xl">🎰</span>
                <span className="text-white font-bold text-xl">
                  ${win.amount.toLocaleString()} MAX WIN
                </span>
                <span className="text-gray-300">•</span>
                <span className="text-gray-300">{win.game}</span>
              </div>
              <p className="text-gray-400 text-sm">
                {win.casino} • {new Date(win.date).toLocaleDateString()}
              </p>
            </div>

            <div className="grid lg:grid-cols-2 gap-8">
              {/* Video Section */}
              <div className="space-y-4">
                <h3 className="text-xl font-bold text-white flex items-center gap-2">
                  <span>🎥</span>
                  The Win
                </h3>
                {win.kickVideoUrl ? (
                  <div className="bg-black/50 rounded-xl p-4 border border-gray-600/30">
                    <a
                      href={win.kickVideoUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block group"
                    >
                      <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-lg p-8 text-center hover:from-green-600 hover:to-green-700 transition-all">
                        <div className="text-5xl mb-3">🎬</div>
                        <div className="text-white font-bold text-lg">
                          Watch This Win on Kick
                        </div>
                        <div className="text-green-100 text-sm mt-2">
                          Click to view the full video
                        </div>
                      </div>
                    </a>
                  </div>
                ) : (
                  <div className="bg-black/50 rounded-xl p-8 border border-gray-600/30 text-center">
                    <div className="text-6xl mb-4">🎰</div>
                    <div className="text-gray-400">Video coming soon</div>
                    <div className="text-gray-500 text-sm mt-1">
                      Check back for the full win footage
                    </div>
                  </div>
                )}
                <div className="bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-xl p-4 border border-purple-400/30">
                  <div className="text-purple-400 font-bold text-lg mb-1">
                    💜 Donated: ${win.donationAmount.toLocaleString()}
                  </div>
                  <div className="text-gray-300 text-sm">{win.description}</div>
                </div>
              </div>

              {/* Patient Story Section */}
              <div className="space-y-4">
                <h3 className="text-xl font-bold text-white flex items-center gap-2">
                  <span>👶</span>
                  Meet {win.recipient}
                </h3>
                <div className="bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-xl p-6 border border-blue-400/30">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="text-6xl">{win.recipientPhoto}</div>
                    <div>
                      <div className="text-white font-bold text-xl">
                        {win.recipient}
                      </div>
                      <div className="text-gray-300">
                        Age {win.recipientAge}
                      </div>
                    </div>
                  </div>
                  <div className="text-gray-300 leading-relaxed mb-4">
                    {win.recipientStory}
                  </div>
                  <div className="bg-gradient-to-r from-green-500/20 to-blue-500/20 rounded-lg p-3 border border-green-400/30">
                    <div className="text-green-400 font-bold text-sm">
                      💚 Impact Made
                    </div>
                    <div className="text-gray-300 text-sm mt-1">
                      This donation helped cover medical expenses and treatment
                      costs
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white px-8 py-3 rounded-full font-bold text-lg transition-all hover:scale-105 shadow-lg hover:shadow-purple-500/25"
        >
          <span>🏠</span>
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default MaxWins;
